<template>
  <GenericCard
    :locked="locked"
    has-delete
    :on-delete="onCardDelete"
    :on-action="submitForm"
    :on-refresh="onCardRefresh"
    :invalid="$v.section.$invalid"
    :dirty="$v.section.$anyDirty"
    :create="create"
    title="Safe Third Country"
    :section="section"
    has-footer
    has-share
    :card-identifier="cardIdentifier"
  >
    <v-form
      :disabled="locked"
      @submit.prevent="submitForm"
    >
      <v-row>
        <v-col cols="12">
          <v-alert
            border="left"
            colored-border
            color="#2A3B4D"
            icon="mdi-information-outline"
            elevation="2"
            class="mb-6"
          >
            For each country through which the applicant traveled, add a module. This module should be used for safe third country bar, INA 208(a)(3); and other transit impacts.
          </v-alert>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          sm="5"
        >
          <v-autocomplete
            v-model="section.country_id"
            outlined
            item-text="name"
            item-value="id"
            :items="optionsCountries"
            label="Putative Country of Transit"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-textarea
            v-model="section.narrative"
            auto-grow
            outlined
            autocomplete="off"
            label="Narrative"
          />
        </v-col>
      </v-row>
    </v-form>
  </GenericCard>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { useVuelidate } from '@vuelidate/core'

import { PARTY_NAMESPACE } from '@/store/party'
import { alertHandler } from '@/alertHandler'

import GenericCard from '@/components/Party/PartyEdit/SectionCards/GenericCard'
import { SHARED_NAMESPACE } from '@/store/shared'

export default {
  name: 'SafeThirdCountriesCard',
  components: { GenericCard },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  setup () {
    return {
      $v: useVuelidate(),
      ...alertHandler(),
    }
  },

  data () {
    return {
      section: {},
    }
  },

  validations () {
    return {
      section: {},
    }
  },

  computed: {
    cardIdentifier () { return `safe-third-countries-card-${this.sectionIdentifier}` },
    create () { return this.item.id === null },

    locked: {
      get () {
        return this.peSafeThirdCountriesCardLock(this.sectionIdentifier)
      },

      set (value) {
        this.setPeSafeThirdCountriesCardLock({ index: this.sectionIdentifier, locked: value })
      },
    },

    optionsCountries () { return this.getCachedDropdown('countries') },
    sectionIdentifier () { return this.section.id || 'new' },

    subtitle () {
      if (this.create) return ''
      return `(${this.section.name})`
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peSafeThirdCountriesCardLock',
    ]),

    ...mapGetters(SHARED_NAMESPACE, [
      'getCachedDropdown',
    ]),
  },

  watch: {
    item: {
      immediate: true,

      handler: function () {
        this.section = { ...this.item }
      },

      deep: true,
    },
  },

  created () {
    if (!this.create) this.initPeSafeThirdCountriesCard(this.sectionIdentifier)
    this.getDropdownOptions({ options: false, path: 'countries' })
  },

  methods: {
    getErrorMessages (validator) { return validator?.$errors.map(e => e.$message) },

    async onCardCreate () {
      return this.peSafeThirdCountriesCardCreate({ index: this.sectionIdentifier, section: this.section })
    },

    async onCardDelete () {
      if (this.create) return this.peSafeThirdCountriesCardCreateUndo()
      else {
        return this.peSafeThirdCountriesCardDelete({ id: this.section.id, index: this.sectionIdentifier })
      }
    },

    async onCardRefresh () {
      return this.peSafeThirdCountriesCardRefresh({ index: this.sectionIdentifier, section: this.section })
    },

    async onCardUpdate () {
      return this.peSafeThirdCountriesCardUpdate({
        id: this.section.id,
        index: this.sectionIdentifier,
        section: this.section,
      })
    },

    async onSectionUnlock () {
      return this.setPeSafeThirdCountriesCardLock({ index: this.sectionIdentifier, locked: false })
    },

    async submitForm () {
      if (this.locked) return this.onSectionUnlock()
      else if (this.create) return this.onCardCreate()
      else return this.onCardUpdate()
    },

    ...mapMutations(PARTY_NAMESPACE, [
      'peSafeThirdCountriesCardCreateUndo',
      'setPeSafeThirdCountriesCardLock',

    ]),

    ...mapActions(PARTY_NAMESPACE, [
      'initPeSafeThirdCountriesCard',
      'peSafeThirdCountriesCardCreate',
      'peSafeThirdCountriesCardDelete',
      'peSafeThirdCountriesCardRefresh',
      'peSafeThirdCountriesCardUpdate',
    ]),

    ...mapActions(SHARED_NAMESPACE, [
      'getDropdownOptions',
    ]),
  },
}
</script>
